import { DrawerContent } from "~/features/MobileDrawerContent";
import { useAppSelector } from "~/store/hooks";

export const useMobileDrawerContent = (): DrawerContent => {
  return useAppSelector((state) => state.mobileDrawerContent.drawerContent);
};
